<template>
  <div>
    <ValidationObserver
      class="form"
      tag="form"
      ref="form"
      novalidate
      @submit.prevent="formSubmit($event)"
    >
      <template v-for="field in fields">
        <FormGroup
          v-if="
            field.type !== 'link' &&
            (!admissionFlows.isInCompanyFlow ||
              (field.ShowFieldForInCompany && admissionFlows.isInCompanyFlow))
          "
          :key="`${field.id}-not-link`"
          :field="field"
          :model="model"
          :rules="field.rules"
          @input="$emit('input', $event)"
          @focus="$emit('focus')"
          @click="readOnlyFieldEvent($event.target)"
        />
        <div
          v-else-if="
            field.type === 'link' &&
            (!admissionFlows.isInCompanyFlow ||
              (field.ShowFieldForInCompany && admissionFlows.isInCompanyFlow))
          "
          :key="field.id"
          class="form__link"
        >
          <a :id="field.id" :href="field.linkRef" target="_blank">
            {{ field.label }}
          </a>
        </div>
      </template>

      <VButton
        class="form__button"
        id="form-btn-send"
        :text="submittButton.text"
        :disabled="submittButton.disabled"
      />
    </ValidationObserver>

    <Modal
      v-show="modalDisplay && clickFieldReadOnly"
      id="modal__form-field-readonly"
      modalPosition="position--bottom"
      :size="{ width: '100%' }"
    >
      <ModalLayoutDefault icon="altaAttendant" :message="modalMessage">
        <VButton
          slot="buttons"
          id="modal__form-btn-field-readonly"
          text="Ok, entendi"
          @click.native="modalChangeFlag(false)"
        />
      </ModalLayoutDefault>
    </Modal>
  </div>
</template>

<script>
import FormGroup from './FormGroup';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';
import '@/utils/helpers/validation/form';

export default {
  name: 'FormTemplate',
  mixins: [dataLayersMixin],
  components: {
    FormGroup,
  },
  data: () => ({
    clickFieldReadOnly: false,
  }),
  props: {
    schema: Object,
    model: Object,
    submittButton: {
      type: Object,
      default: () => ({
        text: 'Continuar',
        disabled: false,
      }),
    },
  },
  computed: {
    ...mapState({
      modalDisplay: ({ modal }) => modal.data.modalDisplay,
    }),

    ...mapGetters({
      admissionFlows: 'global/admissionFlows',
    }),
    fields() {
      return this.schema.fields || [];
    },

    modalMessage() {
      if (this.admissionFlows.isInCompanyFlow) {
        return 'No dia do seu atendimento, o profissional realizará mudanças nos dados cadastrais.';
      }
      return 'Só é possível alterar esta informação em um guichê de atendimento.';
    },
  },
  methods: {
    ...mapMutations({ modalChangeFlag: 'SET_MODAL_DISPLAY' }),
    readOnlyFieldEvent(event) {
      this.clickFieldReadOnly = false;
      if (event.attributes?.readonly) {
        this.modalChangeFlag(true);
        this.clickFieldReadOnly = true;

        this.mostCommonPagesAnalytics({
          eventType: 'funnel_step',
          currentStep: 'Cadastro (modal feedback)',
        });
      }
    },

    async formSubmit(event) {
      const form = this.$refs.form;
      const isFormValid = await form.validate();

      if (!isFormValid) {
        return;
      }

      this.$emit('submit', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  overflow: none;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;

  &__button {
    margin: 25px 0;
  }

  &__link {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 20px;
    font-size: var(--font-size-2);
    color: var(--color-terciary-darken-3);
    text-decoration: underline;
  }
}
</style>
